import React from 'react';
import ErrorMsg from 'src/components/errorMsg';

import { ITextAreaProps } from './InputTextArea.interface';

const InputTextArea = ({
    inputName = '',
    placeholder = '',
    errorText = '',
    className = '',
    label = '',
    tabIndex,
    maxLength,
    minLength,
    disabled,
    onChangeFunc = () => void 0,
    onBlur = () => void 0,
    onFocus,
    required,
    requiredAfter,
    readOnly = false,
    rows = 5,
    value,
    labelClassName = '',
    parentClassName = '',
    handleKeyDown,
    inputMainClassName = '',
    requiredClassName = '',
    labelWrapClass = '',
    labelIconRight,
    inputWrapClass = '',
    isLoading = false,
    textareaRef,
}: ITextAreaProps) => {
    const onHandleChange = (e: any) => {
        onChangeFunc(e);
    };

    const handleInputKeyDown = (e: any) => {
        if (handleKeyDown) {
            handleKeyDown(e);
        }
    };

    return (
        <>
            <div className={`${errorText && typeof errorText !== 'boolean' ? ' mb-2' : ''} ${parentClassName}`}>
                <div className={`${inputMainClassName}`}>
                    <div className={`${labelIconRight ? 'flex justify-between' : ''} ${labelWrapClass}`}>
                        {label && (
                            <label className={`form_label ${labelClassName}`}>
                                {label}
                                {required && <span className={`text-red-600 ms-[2px] leading-4 text-xs ${requiredClassName}`}>*</span>}
                            </label>
                        )}
                        {labelIconRight && labelIconRight}
                    </div>
                    {requiredAfter && <span className="text-red-600 ms-[2px] leading-4 text-xs">*</span>}
                    <div className={`relative flex justify-center items-center ${inputWrapClass} ${isLoading ? 'custom-loading' : ''}`}>
                        <textarea
                            ref={textareaRef}
                            name={inputName}
                            className={`form_control block ignore-blur resize-none custom-scrollbar-v2 ${className} ${errorText && 'is-invalid'}`}
                            placeholder={placeholder}
                            onChange={onHandleChange}
                            onFocus={onFocus}
                            onBlur={onBlur}
                            tabIndex={tabIndex}
                            rows={rows}
                            maxLength={maxLength}
                            minLength={minLength}
                            disabled={disabled}
                            value={value}
                            autoComplete="off"
                            readOnly={readOnly}
                            onKeyDown={handleInputKeyDown}
                        />
                    </div>
                </div>
                {errorText && typeof errorText !== 'boolean' && <ErrorMsg errorText={errorText} />}
            </div>
        </>
    );
};

export default InputTextArea;
